export const calculateAssetValue = (netOperatingIncome: any, capitalisationRate: any): number => {
    if (!!capitalisationRate && !!netOperatingIncome) {
        return parseInt(`${parseFloat(netOperatingIncome) / parseFloat(capitalisationRate) / 100}`);
    }

    return 0;
};
